// @ts-nocheck
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import { OptionProps } from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import { FormFieldStyleProps } from "@store/MobiusOverrides/FormField/FormField";
import { formFieldVariantStyles } from "@store/Themes/common/mixins/formField";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusOutlineStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import CloseCircle from "@store/Library/Components/Toolkit/Icons/CloseCircle/CloseCircleFill";
/* Store Custom Code - End */

const baseOptionStyles = () => {
    return css<OptionProps>`
        ${formFieldVariantStyles()}
        ${x => (x.focused ? focusOutlineStyles(`-${x.theme.focus.width}`) : null)}
        color: ${x => getColor(x.disabled ? "text.disabled" : "text.input")};
        background-color: ${x => getColor(x.disabled ? "common.disabled" : "common.background")};
        border: ${pxToRem(constants.formField.borderWidth)} solid transparent;
        border-top: 0;
        border-bottom: 0;
        transition: ${transitionHoverStyles("color", "background-color")};
    ` as any;
};

const dynamicDropdown: Styleguide["dynamicDropdown"] = {
    defaultProps: {
        iconProps: { src: ChevronDown, size: 16 }, // Store Custom Code
        /* Store Custom Code - Start */
        clearClickable: {
            css: css`
                margin-right: ${pxToRem(-12)};
            `,
        },
        clearIcon: { src: CloseCircle, size: 20 },
        /* Store Custom Code - End */
        cssOverrides: {
            inputSelect: css<FormFieldStyleProps>`
                ${x => x.theme.formField.defaultProps?.cssOverrides?.inputSelect}
                ${({ _sizeVariant, border }) => {
                    /* sizeVariant is unavailable from the list directly, we apply related styles from here */
                    if (border === "rounded") {
                        const { borderRadius } = sizeVariantValues[_sizeVariant];

                        return css`
                            ~ [role="listbox"] {
                                border-radius: 0 0 ${borderRadius}px ${borderRadius}px;
                            }
                        `;
                    }
                }}
            `,
            list: css`
                width: 100%;
                top: 100%;
                border: none;
                box-shadow: ${x => x.theme.shadows.e80};
            `,
            option: css`
                ${baseOptionStyles()}

                &:not([disabled]):hover,
                [role="listbox"]:not(:hover) > &[aria-selected="true"] {
                    background-color: ${getColor("primary")};
                    color: ${getColor("primary.contrast")};
                }
            `,
            noOptions: css`
                ${baseOptionStyles()}
                color: ${getColor("placeholder")};
                font-style: italic;
                cursor: initial;
            `,
            moreOption: css`
                ${baseOptionStyles()}
                cursor: initial;
            `,
        },
    },
};

export default dynamicDropdown;
